import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Formik } from 'formik';
import { format } from '@origo_vl_banking/utils';
import { TextInput } from '@origo_vl_banking/ibanking-react';
import { useSelector, useDispatch } from 'react-redux';

import { Hr, SpaceBetween } from '../../../components/grid/styled-components';
import { InputWrapper, AmountWrapper } from '../../../components/shared/styled-components';
import { setTermsDueDateCount, calcConsolidation } from '../actions'; 



const MonthCalculator = () => {
  const consolidation = useSelector((state) => state.consolidation);
  const dispatch = useDispatch(); 

  return (
    <Formik
      initialValues={{ dueDateCount: consolidation.dueDateCount }}
      onSubmit={() => {}}
    >
      {({ touched, errors, handleBlur, handleChange }) => {
        const handleDateBlur = (e) => {
          handleBlur(e);
          const newValue = String(e.target.value).padStart(3, '0');
          if (newValue !== consolidation.dueDateCount) {
            dispatch(setTermsDueDateCount(newValue)); 
            dispatch(calcConsolidation());
          }
        };

        return (
          <>
            <SpaceBetween>
              <InputWrapper>
                <TextInput
                  label="Application.DueDateCount"
                  name="dueDateCount"
                  normalize="amount"
                  height="34px"
                  value={consolidation.dueDateCount}
                  error={
                    (touched.dueDateCount && errors.dueDateCount) ||
                    (!touched.dueDateCount && !consolidation.dueDateCount)
                  }
                  onBlur={handleDateBlur}
                  onChange={handleChange}
                  disabled={!consolidation.editable}
                  star="red"
                  tabIndex="3"
                />
              </InputWrapper>
              <AmountWrapper>
                <b>
                  <FormattedMessage id="Application.PlannedAveragePayment" />
                </b>
                <h4 style={{ marginTop: '8px' }}>
                  {format.amount(Math.round(consolidation.plannedAveragePayment || 0))} kr.
                </h4>
              </AmountWrapper>
            </SpaceBetween>
            <Hr />
          </>
        );
      }}
    </Formik>
  );
};

export default MonthCalculator;
